export default ({
  namespaced: true,
  state: {
    models: []
  },
  mutations: {
    SET_MODELS (state, data) {
      state.models = data
    }
  },
  actions: {
    async get ({ commit, rootState, dispatch }, url, ad) {
      console.log(ad)
      await this._vm.$axios.get(url, { headers: rootState.user.axiosHeaders })
        .then(res => {
          commit('SET_MODELS', res.data)
        })
        .catch(async (err) => {
          if ('code' in err.response.data && err.response.data.code === 'token_not_valid') {
            await dispatch('user/refreshToken', null, { root: true })
              .then(async () => {
                await dispatch('getModels')
              })
              .catch(err => {
                console.log(err.response.data)
                this.$router.push('/login')
              })
          }
        })
    }
  }
})
